import React from "react";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import methodIcon from "../../../../images/method-icon.svg";
import Pagination from "@material-ui/lab/Pagination";
import PrimaryButton from "../../../../components/PrimaryButton";
import { Link } from "react-router-dom";
import GridTable from "../../../../components/GridTable";
import Chip from "@material-ui/core/Chip";

const useStyles = makeStyles((theme) => ({
  searchBar: {
    width: "75%",
    backgroundColor: "white",
    marginLeft: "3%",
    marginTop: "2%",
  },
  formControl: {
    margin: theme.spacing(1),
    marginLeft: "3%",
    marginTop: "2%",
    minWidth: 120,
    backgroundColor: "white",
    width: "10%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  gridRoot: {
    flexGrow: 1,
  },
  gridContainer: {
    width: "90%",
    marginLeft: "3%",
    marginTop: "3%",
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: "left",
    padding: "10%",
    color: theme.palette.text.secondary,
    //color: "#404040",
    height: "30vh",
    fontWeight: "400",
    fontSize: "0.85rem",
  },
  methodName: {
    marginLeft: 10,
  },
  myButton: {
    float: "right",
    marginRight: "8%",
    marginTop: "2%",
  },
  methodContent: {
    marginTop: "10%",
  },
  tags: {
    marginTop: "10%",
    fontWeight: 100,
    "& > *": {
      margin: theme.spacing(0.5),
    },
  },
}));

const MyMethods = () => {
  const classes = useStyles();
  const [sort, setSort] = React.useState("");
  const handleChange = (event) => {
    setSort(event.target.value);
  };

  return (
    <>
      <TextField
        id="outlined-basic"
        label="Search methods..."
        variant="outlined"
        className={classes.searchBar}
      />
      <FormControl variant="outlined" className={classes.formControl}>
        <InputLabel id="demo-simple-select-outlined-label">Sort By</InputLabel>
        <Select
          labelId="demo-simple-select-outlined-label"
          id="demo-simple-select-outlined"
          value={sort}
          onChange={handleChange}
          label="Sort By"
        >
          <MenuItem value={10}>Date</MenuItem>
          <MenuItem value={20}>Alphabetical</MenuItem>
          <MenuItem value={30}>Usage</MenuItem>
        </Select>
      </FormControl>

      <div className={classes.gridRoot}>
        <Grid container spacing={5} className={classes.gridContainer}>
          <Grid item xs={4}>
            <Paper className={classes.paper} elevation={0}>
              <GridTable
                tableContent={[
                  {
                    key: <img src={methodIcon} alt="method-icon" />,
                    value: "Prostate cancer tumor size classification",
                  },
                ]}
                keySize={2}
                valueSize={9}
              />

              <div className={classes.methodContent}>
                <GridTable
                  tableContent={[
                    {
                      key: "Progress",
                      value: "Completed",
                    },
                    { key: "Last Updated", value: "02/23/2021" },
                    { key: "Status", value: "In queue" },
                  ]}
                  keySize={6}
                  valueSize={6}
                />
              </div>
              <div className={classes.tags}>
                <Chip label="cancer" size="small" color="default" />
              </div>
            </Paper>
          </Grid>

          <Grid item xs={4}>
            <Paper className={classes.paper} elevation={0}>
              <GridTable
                tableContent={[
                  {
                    key: <img src={methodIcon} alt="method-icon" />,
                    value: "MoA Prediction",
                  },
                ]}
                keySize={2}
                valueSize={9}
              />
              <div className={classes.methodContent}>
                <GridTable
                  tableContent={[
                    {
                      key: "Progress",
                      value: "Completed",
                    },
                    { key: "Last Updated", value: "02/28/2021" },
                    { key: "Status", value: "Running" },
                  ]}
                  keySize={6}
                  valueSize={6}
                />
              </div>
              <div className={classes.tags}>
                <Chip label="drugs" size="small" color="default" />
                <Chip label="multiclass" size="small" color="default" />
                <Chip label="moa" size="small" color="default" />
              </div>
            </Paper>
          </Grid>
          <Grid item xs={4}>
            <Paper className={classes.paper} elevation={0}>
              <GridTable
                tableContent={[
                  {
                    key: <img src={methodIcon} alt="method-icon" />,
                    value: "Protein folding experiment",
                  },
                ]}
                keySize={2}
                valueSize={9}
              />

              <div className={classes.methodContent}>
                <GridTable
                  tableContent={[
                    {
                      key: "Progress",
                      value: "Model",
                    },
                    { key: "Last Updated", value: "03/10/2021" },
                    { key: "Status", value: "Not Submitted" },
                  ]}
                  keySize={6}
                  valueSize={6}
                />
              </div>
              <div className={classes.tags}>
                <Chip label="protein folding" size="small" color="default" />
                <Chip label="deep model" size="small" color="default" />
              </div>
            </Paper>
          </Grid>
          <Pagination count={3} />
        </Grid>
      </div>
      <Link to="methods/new-method">
        <PrimaryButton innerText="New Method" styleClasses={classes.myButton} />
      </Link>
    </>
  );
};

export default MyMethods;
